<template>
  <v-container fluid class="pa-0 normativa-container">
    <!-- Card Principal com Tabs -->
    <div v-if="permissao('normativa_admin')" class="dashboard-header">
      <div class="header-content">
        <div class="d-flex align-center">
          <div class="icon-wrapper">
            <v-icon color="#023449" size="28">mdi-book-open-page-variant</v-icon>
          </div>
          <div class="ml-3">
            <h1 class="dashboard-title">Sistema de Normativas</h1>
            <p class="dashboard-subtitle">Gestão de documentos e categorias da empresa</p>
          </div>
        </div>
      </div>

      <!-- Navegação com Tabs -->
      <div class="header-actions">
        <v-btn-toggle
            v-model="abaAtiva"
            color="#023449"
            mandatory
            class="nav-toggle"
        >
          <v-btn value="0">
            <v-icon left small>mdi-file-document-multiple</v-icon>
            <span class="d-none d-sm-inline">Normativas</span>
          </v-btn>
          <v-btn value="1">
            <v-icon left small>mdi-shape</v-icon>
            <span class="d-none d-sm-inline">Categorias</span>
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>

    <!-- Cabeçalho Simples (sem permissão admin) -->
    <div v-else class="dashboard-header">
      <div class="header-content">
        <div class="d-flex align-center">
          <div class="icon-wrapper">
            <v-icon color="#023449" size="28">mdi-file-document-multiple</v-icon>
          </div>
          <div class="ml-3">
            <h1 class="dashboard-title">Normativas</h1>
            <p class="dashboard-subtitle">Consulte e faça download das normativas da empresa</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo das Abas -->
    <div class="dashboard-content">
      <transition name="page-fade" mode="out-in">
        <component :is="componenteAtivo" :key="abaAtiva" />
      </transition>
    </div>
  </v-container>
</template>

<script>
import NormativaLista from './Normativas/NormativaLista.vue'
import CategoriaLista from './Categorias/CategoriaLista.vue'

export default {
  name: 'NormativaContainer',

  components: {
    NormativaLista,
    CategoriaLista
  },

  data() {
    return {
      abaAtiva: 0
    }
  },

  computed: {
    componenteAtivo() {
      return this.abaAtiva === 0 || this.abaAtiva === '0' ? 'NormativaLista' : 'CategoriaLista'
    }
  },

  mounted() {
    const abaUrl = this.$route?.query?.aba
    if (abaUrl === 'categorias' && this.permissao('normativa_admin')) {
      this.abaAtiva = 1
    } else {
      this.abaAtiva = 0
    }
  },

  watch: {
    abaAtiva(novaAba) {
      if (!this.permissao('normativa_admin')) return

      const abaParam = (novaAba === 1 || novaAba === '1') ? 'categorias' : 'normativas'
      if (this.$route?.query?.aba !== abaParam) {
        this.$router?.replace({
          query: { ...this.$route.query, aba: abaParam }
        }).catch(() => {})
      }
    }
  },
}
</script>

<style scoped>
.normativa-container {
  min-height: calc(100vh - 300px);
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 0 8px 8px 8px;
}

/* Header Section */
.dashboard-header {
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px rgba(2, 52, 73, 0.04);
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 20px;
}

.header-content {
  flex: 1;
}

.icon-wrapper {
  background: linear-gradient(135deg, rgba(2, 52, 73, 0.08) 0%, rgba(2, 52, 73, 0.04) 100%);
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #023449;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.dashboard-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 4px 0 0 0;
  font-weight: 400;
}

.header-actions {
  display: flex;
  gap: 12px;
}

/* Navegação com Toggle */
::v-deep .nav-toggle {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(2, 52, 73, 0.04);
}

::v-deep .nav-toggle .v-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  font-size: 0.875rem;
  color: #64748b;
  border-radius: 0 !important;
  padding: 0 20px !important;
  height: 44px !important;
}

::v-deep .nav-toggle .v-btn--active {
  background-color: #023449 !important;
  color: #ffffff !important;
}

::v-deep .nav-toggle .v-btn:not(.v-btn--active):hover {
  background-color: rgba(2, 52, 73, 0.04);
}

::v-deep .nav-toggle .v-btn .v-icon {
  color: inherit;
}

/* Content Area */
.dashboard-content {
  padding: 0;
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Transição de páginas */
.page-fade-enter-active, .page-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.page-fade-enter {
  opacity: 0;
  transform: translateY(8px);
}

.page-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* Responsividade */
@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    padding: 20px;
  }

  .header-actions {
    width: 100%;
  }

  ::v-deep .nav-toggle {
    width: 100%;
  }

  ::v-deep .nav-toggle .v-btn {
    flex: 1;
  }

  .dashboard-title {
    font-size: 1.25rem;
  }

  .dashboard-subtitle {
    font-size: 0.813rem;
  }
}

@media (max-width: 480px) {
  .dashboard-title {
    font-size: 1.125rem;
  }

  .icon-wrapper {
    padding: 10px;
  }

  .icon-wrapper >>> .v-icon {
    font-size: 24px !important;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .dashboard-content,
  .page-fade-enter-active,
  .page-fade-leave-active {
    animation: none !important;
    transition: none !important;
  }
}
</style>